import { useEffect, useRef, useState } from "react";
export function useListingBatch(length, key) {
  const [state, setState] = useState({ key, count: 12 });
  const count = state.key === key ? state.count : 12;
  const sentinel = useRef(null);
  useEffect(() => {
    const el = sentinel.current;
    if (!el || count >= length) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setState(s => ({ key, count: (s.key === key ? s.count : 12) + 12 }));
    }, { rootMargin: "300px" });
    observer.observe(el);
    return () => observer.disconnect();
  }, [length, count, key]);
  return { count, sentinel };
}
